module.exports = __webpack_public_path__ + "static/media/swap.f0ee1a6d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/swap.svg
// module id = 84
// module chunks = 0